import { render, staticRenderFns } from "./RCCR.vue?vue&type=template&id=4b472a99&"
import script from "./RCCR.vue?vue&type=script&lang=ts&"
export * from "./RCCR.vue?vue&type=script&lang=ts&"
import style0 from "./RCCR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports